module.exports = __webpack_public_path__ + "img/clock-picker.de20db60.svg";